import { Icon } from "@iconify/react";
import { useQuery } from "@tanstack/react-query";
import Spinner from "Components/CommonComponents/Spinner";
import { toPlainFields } from "Components/support/Allfields/fieldconverter";
import { StonePopUpFieldsForPurchaseAndInvoice } from "Components/support/Allfields/Stonepopup";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useFieldArray, useForm, useWatch } from "react-hook-form";
import { FaTrash, FaTrashAlt } from "react-icons/fa";
import { fetchAllStones } from "services/generalService";
import { generateDropDownList } from "utils/helpers";
const defaultValue = {
  StoneName: "",
  StoneShape: "",
  StoneColor: "",
  StoneSize: "",
  StoneWeight: "",
  StoneRateKarate: "",
  StonePieces: "",
  StoneRatePiece: "",
  StoneAmount: "",
  StoneSettingType: "",
  StoneCertificate: "",
  StonePacket: "",
  StoneBox: "",
  Description: "",
  StoneStatusType: "",
};
const StockStonePopUpNew = ({
  dropdownListData,
  onClose,
  clientCode,
  addStone,
  Stones,
  customerName,
  StockKeepingUnit,
  skuList
}) => {
  const { data: stonesList,isLoading:stonesListLoading } = useQuery({
    queryKey: ["/addStock/StonesList", clientCode],
    queryFn: fetchAllStones,
    refetchOnWindowFocus: false,
    cacheTime: 1000 * 60 * 5,
    staleTime: 1000 * 60 * 5,
  });
  const [fields, setFields] = useState(() => {
    return Stones?.length
      ? Stones
      : [
          {
            StoneName: "",
            StoneColour: "",
            StoneShape: "",
            StoneSize: "",
            StoneWeight: "",
            StonePieces: "",
            StoneRatePiece: "",
            StoneRateKarate: "",
            StoneAmount: "",
            Description: "",
          },
        ];
  });

  const stoneRefs = useRef([]);

  const skuStones = useMemo(()=>{
     if(StockKeepingUnit?.value){
      const foundSku = skuList?.find((item)=>item?.Id == StockKeepingUnit?.value)
      if(foundSku?.SKUStoneMain?.length){
         return foundSku?.SKUStoneMain?.map((item)=>{return{
          StoneName:item?.StoneMainName,
          StoneColour:"",
          StoneShape:"",
          StoneSize:"",
          StoneWeight:(+(item?.StoneMainWeight || 0))?.toFixed(3),
          StonePieces:item?.StoneMainPieces,
          StoneRatePiece:"",
          StoneRateKarate:(+(item?.StoneMainRate))?.toFixed(2),
          Description:item?.StoneMainDescription,
          StoneStatusType:"deduct"

         }})
      }else{
        return []
      }
     }
  },[StockKeepingUnit?.value,skuList])
  useEffect(() => {
    setTimeout(() => {
      if (stoneRefs.current[0]) {
        stoneRefs.current[0].focus();
      }
    }, 200);
  }, []);



  const handleAddRow = () => {
    setFields([
      ...fields,
      {
        StoneName: "",
        StoneColour: "",
        StoneShape: "",
        StoneSize: "",
        StoneWeight: "",
        StonePieces: "",
        StoneRatePiece: "",
        StoneRateKarate: "",
        StoneAmount: "",
        Description: "",
      },
    ]);

    setTimeout(() => {
      if (stoneRefs.current[fields.length]) {
        stoneRefs.current[fields.length].focus();
      }
    }, 200);
  };

  const handleRemoveRow = (index) => {
    setFields(fields.filter((_, idx) => idx !== index));
  };

  const handleSave = () => {
    console.log(fields);
    addStone({ stones: fields });
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0, 0, 0, 0.3)", // Semi-transparent background
        backdropFilter: "blur(5px)", // Blur effect
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          // maxWidth: "1000px",
          width: "95%",
          maxHeight: "80vh",
          background: "#fff",
          // padding: "20px",
          borderRadius: "10px",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            // marginBottom: "15px",
            padding: '0px 20px',
            background: '#627383'
          }}
        >
          <p style={{ fontSize: "16px", fontWeight: "bold" , color: '#fff'}}>
            Add Stone Details
          </p>
          <Icon
            icon="carbon:close-filled"
            onClick={onClose}
            style={{ cursor: "pointer", fontSize: "25px", color: '#fff' }}
          />
        </div>
        <form style={{ display: "flex", flexDirection: "column", padding: '20px' }}>
          <div
            style={{ maxHeight: "50vh", overflowY: "auto", padding: "10px",position:'relative' }}
          >
            {stonesListLoading && <div  style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(255, 255, 255, 0.8)", // Covers full area
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontWeight: "bold",
        zIndex: 10, // Ensures it appears above content
      }}>loading...</div>}
            {fields?.length
              ? fields.map((item, idx) => (
                  <Stone
                    item={item}
                    idx={idx}
                    dropdownListData={dropdownListData}
                    stonesList={
                      StockKeepingUnit?.value && skuStones?.length ? skuStones : 
                      stonesList}
                    stoneRefs={stoneRefs}
                    handleRemoveRow={handleRemoveRow}
                    fields={fields}
                    setFields={setFields}
                    customerName={customerName}
                    handleAddRow={handleAddRow}
                    stonesListLoading={stonesListLoading}
                  />
                ))
              : ""}
          </div>

          

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              // gap: "10px",
              // marginTop: "15px",
            }}
          >
            <div style={{display: 'flex', gap: '10px'}}>
            <button
              type="button"
              onClick={onClose}
              style={{
                padding: "8px 15px",
                borderRadius: "5px",
                backgroundColor: "#0077d4",
                color: "#fff",
                cursor: "pointer",
                border: "none",
              }}
            >
              <Icon icon="maki:cross" width="24" height="24" />
              Cancel
            </button>

            <button
              type="button"
              onClick={handleSave}
              style={{
                padding: "8px 15px",
                borderRadius: "5px",
                backgroundColor: "#0077d4",
                color: "#fff",
                cursor: "pointer",
                border: "none",
              }}
            >
              <Icon icon="mingcute:check-fill" width="24" height="24" />
              Save
            </button>
            </div>
          
          </div>
        </form>
      </div>
    </div>
  );
};

export default StockStonePopUpNew;

function Stone({
  item,
  idx,
  dropdownListData,
  stonesList,
  stoneRefs,
  handleRemoveRow,
  fields,
  setFields,
  customerName,
  handleAddRow,
  stonesListLoading

}) {
  const handleChange = (index, field, value) => {
    let updatedFields = {};
    if (field == "StoneName") {
      const foundStone =
        stonesList?.length &&
        stonesList?.find((item) => item?.StoneName == value);
      // const CustomerTounch = CustomerTounchList?.length && CustomerTounchList?.find((item)=>item?.CustomerId == customerName?.value)
      // const CustomerTounchStone = CustomerTounch?.Stones?.length && CustomerTounch?.Stones?.find((item)=>item?.StoneName == value)
      updatedFields = fields.map((item, idx) =>
        idx === index
          ? {
              ...item,
              StoneName: value,
              StoneColour: foundStone?.StoneColour,
              StoneShape: foundStone?.StoneShape,
              StoneSize: foundStone?.StoneSize,
              StoneWeight: (+(foundStone?.StoneWeight || 0))?.toFixed(3),
              StonePieces: foundStone?.StonePieces,
              StoneRatePiece: (+(foundStone?.StoneRatePiece || 0))?.toFixed(2),
              StoneRateKarate: (+(foundStone?.StoneRate || 0))?.toFixed(2),
              // StoneAmount:foundStone?.StoneRateKarate,
              Description: foundStone?.Description,
              StoneStatusType: foundStone?.StoneStatusType,
            }
          : item
      );
    } else {
      updatedFields = fields.map((item, idx) =>
        idx === index ? { ...item, [field]: value } : item
      );
    }

    setFields(updatedFields);
  };

  useEffect(() => {
    const updatedFields = {
      ...fields[idx],
      StoneAmount: (
        +(item?.StoneRateKarate || 0) * +(item?.StoneWeight || 0)
      )?.toFixed(2),
    };
    setFields((prevFields) => {
      const newFields = [...prevFields];
      newFields[idx] = updatedFields; // Replace item at idx
      return newFields;
    });
  }, [item?.StoneWeight, item?.StoneRateKarate]);
  return (
    <div
      key={idx}
      style={{
        display: "flex",
        alignItems: "end",
        gap: "10px",
        marginBottom: "10px",
        flexWrap: "nowrap",
        justifyContent: 'space-between'
      }}
    >
      <label
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "5px",
          alignItems: "start",
        }}
      >
        Stone Name
        <select
          ref={(el) => (stoneRefs.current[idx] = el)}
          value={item.StoneName}
          onChange={(e) => handleChange(idx, "StoneName", e.target.value)}
          style={{
            width: "120px",
            padding: "5px",
            border: "1px solid #ccc",
            borderRadius: "4px",
            height: "38px",
          }}
        >
          <option value="">Select Stone</option>
          {generateDropDownList({
            field:{ key: "StoneName" },
            dropdownListData:{ ...dropdownListData, stonesList: stonesList }
})?.map((stone) => (
            <option key={stone.id} value={stone.value}>
              {stone.label}
            </option>
          ))}
        </select>
      </label>

      <label
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "5px",
          alignItems: "start",
        }}
      >
        Color
        <select
          value={item.StoneColour}
          onChange={(e) => handleChange(idx, "StoneColour", e.target.value)}
          style={{
            width: "120px",
            padding: "5px",
            border: "1px solid #ccc",
            borderRadius: "4px",
            height: "38px",
          }}
        >
          <option value="">Select Color</option>
          {[]?.map((stone) => (
            <option key={stone.id} value={stone.name}>
              {stone.name}
            </option>
          ))}
        </select>
      </label>

      <label
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "5px",
          alignItems: "start",
        }}
      >
        Shape
        <select
          value={item.StoneShape}
          onChange={(e) => handleChange(idx, "StoneShape", e.target.value)}
          style={{
            width: "120px",
            padding: "5px",
            border: "1px solid #ccc",
            borderRadius: "4px",
            height: "38px",
          }}
        >
          <option value="">Select Shape</option>
          {[]?.map((stone) => (
            <option key={stone.id} value={stone.name}>
              {stone.name}
            </option>
          ))}
        </select>
      </label>

      <label
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "5px",
          alignItems: "start",
        }}
      >
        Size
        <select
          value={item.StoneSize}
          onChange={(e) => handleChange(idx, "StoneSize", e.target.value)}
          style={{
            width: "120px",
            padding: "5px",
            border: "1px solid #ccc",
            borderRadius: "4px",
            height: "38px",
          }}
        >
          <option value="">Select Size</option>
          {[]?.map((stone) => (
            <option key={stone.id} value={stone.name}>
              {stone.name}
            </option>
          ))}
        </select>
      </label>

      <label
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "5px",
          alignItems: "start",
        }}
      >
        Weight
        <input
          type="number"
          placeholder="Weight"
          step={"any"}
          value={item.StoneWeight}
          onChange={(e) => handleChange(idx, "StoneWeight", e.target.value)}
          style={{
            width: "120px",
            padding: "5px",
            border: "1px solid #ccc",
            borderRadius: "4px",
            height: "38px",
          }}
        />
      </label>

      <label
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "5px",
          alignItems: "start",
        }}
      >
        Pieces
        <input
          type="number"
          placeholder="Pieces"
          value={item.StonePieces}
          onChange={(e) => handleChange(idx, "StonePieces", e.target.value)}
          style={{
            width: "120px",
            padding: "5px",
            border: "1px solid #ccc",
            borderRadius: "4px",
            height: "38px",
          }}
        />
      </label>

      <label
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "5px",
          alignItems: "start",
        }}
      >
        Rate/Pieces
        <input
          type="number"
          placeholder="Rate/Pieces"
          step={"any"}
          value={item.StoneRatePiece}
          onChange={(e) => handleChange(idx, "StoneRatePiece", e.target.value)}
          style={{
            width: "120px",
            padding: "5px",
            border: "1px solid #ccc",
            borderRadius: "4px",
            height: "38px",
          }}
        />
      </label>

      <label
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "5px",
          alignItems: "start",
        }}
      >
        Rate/Weight
        <input
          type="number"
          placeholder="Rate/Karate"
          step={"any"}
          value={item.StoneRateKarate}
          onChange={(e) => handleChange(idx, "StoneRateKarate", e.target.value)}
          style={{
            width: "120px",
            padding: "5px",
            border: "1px solid #ccc",
            borderRadius: "4px",
            height: "38px",
          }}
        />
      </label>

      <label
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "5px",
          alignItems: "start",
        }}
      >
        Amount
        <input
          type="number"
          placeholder="Amount"
          value={item.StoneAmount}
          onChange={(e) => handleChange(idx, "StoneAmount", e.target.value)}
          style={{
            width: "120px",
            padding: "5px",
            border: "1px solid #ccc",
            borderRadius: "4px",
            height: "38px",
          }}
        />
      </label>

      <label
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "5px",
          alignItems: "start",
        }}
      >
        Description
        <input
          type="text"
          placeholder="Description"
          value={item.Description}
          onChange={(e) => handleChange(idx, "Description", e.target.value)}
          style={{
            width: "120px",
            padding: "5px",
            border: "1px solid #ccc",
            borderRadius: "4px",
            height: "38px",
          }}
        />
      </label>

      <div style={{display: 'flex', gap: '10px'}}>
      <button
            type="button"
            onClick={handleAddRow}
            style={{
              backgroundColor: "#627383",
              color: "#fff",
              border: "none",
              padding: "5px 10px",
              borderRadius: "5px",
              cursor: "pointer",
              height: "38px",
            }}
            disabled={stonesListLoading}
          >
            <Icon icon="tabler:plus" width="24" height="24" />
          </button>
      <button
        type="button"
        onClick={() => handleRemoveRow(idx)}
        style={{
          backgroundColor: "#627383",
          color: "#fff",
          border: "none",
          padding: "5px 10px",
          borderRadius: "5px",
          cursor: "pointer",
          height: "38px",
        }}
      >
        <FaTrash size={20} />
      </button>
      
         
      </div>

      
    </div>
  );
}
